import { Injectable, signal } from '@angular/core';

import { BaseService } from '../base/services';

@Injectable()
export class ForbiddenService extends BaseService {
  private readonly forbiddenState = signal(false);
  readonly isForbidden = this.forbiddenState.asReadonly();
  forbid(): void {
    this.forbiddenState.set(true);
  }

  allow(): void {
    this.forbiddenState.set(false);
  }
}
